import type { EntityOption } from '@/components/EntitySelect';
import { createContact, getContact, listContacts } from './api';
import { contactName } from './types';

/** Server search for the contact picker (EntitySelect). */
export async function searchContacts(query: string): Promise<EntityOption[]> {
  const page = await listContacts({ search: query || undefined });
  return page.results.map((c) => ({ value: String(c.id), label: contactName(c) }));
}

/** Inline-create a contact from a picker (EntitySelect `onCreate`). The typed
 *  text is split into first/last name. */
export async function createContactOption(name: string): Promise<EntityOption> {
  const [first, ...rest] = name.trim().split(/\s+/);
  const contact = await createContact({
    company: null,
    first_name: first,
    last_name: rest.join(' '),
    email: '',
    phone_number: '',
    title: '',
    notes: '',
  });
  return { value: String(contact.id), label: contactName(contact) };
}

/** Resolve a contact's name for a preselected id (edit mode). */
export async function resolveContactLabel(value: string): Promise<string | null> {
  if (!value) return null;
  const contact = await getContact(Number(value));
  return contactName(contact);
}
